import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'boxicons/css/boxicons.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './index.css';
import './App.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import registerServiceWorker from './services/serviceWorker';

// Importa o MenuProvider
import { MenuProvider } from './context/MenuProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MenuProvider>
      <App />
    </MenuProvider>
  </React.StrictMode>
);

reportWebVitals();
registerServiceWorker();